module.exports = __webpack_public_path__ + "static/img/materialsInfo7.b83b204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo7.png
// module id = 0OS9
// module chunks = 2